import React from 'react';
import * as Styles from 'pages/member/manage-vm/ManageVM.style';

const ServerImageComponent = ({ data }) => {
  return (
    <Styles.ServerImage>
      {data.os == 'windows' ? (
        <i className="fa fa-windows fa-2x" />
      ) : data.os == 'linux' ? (
        <i className="fa fa-linux fa-2x" />
      ) : null}
    </Styles.ServerImage>
  );
};

export const ServerImage = React.memo(ServerImageComponent);
